import qs from "query-string";

export function useIsCompact(locationSearch) {
  const parsed = qs.parse(locationSearch);

  const isCompact = parsed?.compact === "true";

  return isCompact;
}
